import { c as _c } from "react/compiler-runtime";
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import type { DataIdentifier, Entity } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import { EncryptedCell } from '@/components';
import Field from '../../../../../field';
import checkCountryCode from '../utils/check-country-code';
import getInitialCountry from '../utils/get-initial-country';
export type CountryOfBirthType = {
  di: DataIdentifier;
  entity: Entity;
};
const CountryOfBirth = t0 => {
  const $ = _c(7);
  const {
    di,
    entity
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "di"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  let t2;
  if ($[1] !== t) {
    t2 = () => t(_temp2);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== di || $[4] !== entity || $[5] !== t2) {
    t3 = <Field di={di} entity={entity} renderValue={_temp} renderLabel={t2} />;
    $[3] = di;
    $[4] = entity;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default CountryOfBirth;
function _temp(value) {
  if (checkCountryCode(value as string)) {
    return <div className="text-body-2 text-primary" data-dd-privacy="mask">{getInitialCountry(value as Iso3166TwoDigitCountryCode).label}</div>;
  }
  return <EncryptedCell />;
}
function _temp2($) {
  return $.id.country_of_birth;
}